
import React from 'react';
import { Button } from "@/components/ui/button";
import { Trash2 } from 'lucide-react';
import { PlaceDeleteDialog } from './PlaceDeleteDialog';
import { PlaceCollectionManagement } from './collection/PlaceCollectionManagement';

interface PlaceActionButtonsProps {
  isCollectionOwner: boolean;
  isOwner: boolean;
  placeName: string;
  onRemoveFromCollection: () => void;
  onDelete: () => void;
}

export function PlaceActionButtons({
  isCollectionOwner,
  isOwner,
  placeName,
  onRemoveFromCollection,
  onDelete
}: PlaceActionButtonsProps) {
  return (
    <div className="ml-4 flex gap-2">
      {isCollectionOwner && !isOwner && (
        <PlaceCollectionManagement
          isCollectionOwner={isCollectionOwner}
          isOwner={isOwner}
          placeName={placeName}
          onRemove={onRemoveFromCollection}
        />
      )}
      {isOwner && (
        <PlaceDeleteDialog onDelete={onDelete} />
      )}
    </div>
  );
}
